// @ts-nocheck
import ReactApexChart from 'react-apexcharts';

const Area = ({ categories, series, height = 350 }) => {
  const themeFont = getComputedStyle(document.body).getPropertyValue('--bs-body-font-family').trim();
  const inverse = getComputedStyle(document.body).getPropertyValue('--bs-inverse').trim();
  const inverseRgb = getComputedStyle(document.body).getPropertyValue('--bs-inverse-rgb').trim();
  const themeFontWeight = getComputedStyle(document.body).getPropertyValue('--bs-body-font-weight').trim();
  const gray500 = getComputedStyle(document.body).getPropertyValue('--bs-gray-500').trim();
  // const orange = getComputedStyle(document.body).getPropertyValue('--bs-warning').trim();
  const borderColor = getComputedStyle(document.body).getPropertyValue('--bs-border-color').trim();
  const themeColorRgb = getComputedStyle(document.body).getPropertyValue('--bs-theme-rgb').trim();

  const gray600 = getComputedStyle(document.body).getPropertyValue('--bs-gray-600').trim();
  const pink = getComputedStyle(document.body).getPropertyValue('--bs-pink').trim();

  const AreaOptions = {
    // dataLabels: { enabled: false },
    stroke: { curve: 'smooth', width: 3 },
    colors: ['var(--bs-theme)', gray600],
    // colors: [pink, gray600],
    grid: { borderColor: borderColor },
    xaxis: {
      // type: 'datetime',
      // categories: [
      //   '2024-09-19T00:00:00',
      //   '2024-09-19T01:30:00',
      //   '2024-09-19T02:30:00',
      //   '2024-09-19T03:30:00',
      //   '2024-09-19T04:30:00',
      //   '2024-09-19T05:30:00',
      //   '2024-09-19T06:30:00',
      // ],
      categories,
      axisBorder: {
        show: true,
        color: 'rgba(' + inverseRgb + ', .25)',
        height: 1,
        width: '100%',
        offsetX: 0,
        offsetY: -1
      },
      axisTicks: {
        show: true,
        borderType: 'solid',
        color: 'rgba(' + inverseRgb + ', .25)',
        height: 6,
        offsetX: 0,
        offsetY: 0
      },
      labels: {
        style: {
          colors: inverse,
          fontSize: '12px',
          fontFamily: themeFont,
          fontWeight: themeFontWeight,
          cssClass: 'apexcharts-xaxis-label'
        }
      }
    },
    yaxis: {
      labels: {
        style: {
          colors: inverse,
          fontSize: '12px',
          fontFamily: themeFont,
          fontWeight: themeFontWeight,
          cssClass: 'apexcharts-xaxis-label'
        }
      }
    },
    legend: { fontFamily: themeFont, labels: { colors: inverse } }
    // tooltip: { x: { format: 'dd/MM/yy HH:mm' } },
  };

  return <ReactApexChart options={AreaOptions} series={series} type='area' height={height} />;
};

export default Area;
